export interface Movie {
  id: string;
  title: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  image: string;
  description: string;
  director: string;
  cast: string[];
  duration: string;
  type: 'tv' | 'movie' | 'variety' | 'anime' | 'documentary';
  isHot: boolean;
  isNew: boolean;
  isClassic: boolean;
  episodes?: string;
  region: string;
}

export const categories = [
  { name: '电视剧', slug: 'tv-series', icon: 'ri-tv-line' },
  { name: '电影', slug: 'movies', icon: 'ri-film-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-live-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-rocket-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-slideshow-line' },
];

export const movies: Movie[] = [
  {
    id: 'tv-001',
    title: '长安十二时辰',
    year: 2019,
    category: '电视剧',
    categorySlug: 'tv-series',
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20period%20drama%20movie%20poster%20with%20Tang%20Dynasty%20aesthetic%2C%20mysterious%20atmosphere%2C%20dim%20lantern%20lighting%2C%20traditional%20costume%2C%20cinematic%20composition%2C%20dark%20moody%20background%20with%20warm%20golden%20accents%2C%20film%20poster%20style&width=600&height=800&seq=tv-001&orientation=portrait',
    description: '该剧改编自马伯庸同名小说，讲述了唐朝上元节前夕，长安城陷入危局，长安死囚张小敬临危受命，与李必携手在十二时辰内拯救长安的故事。剧情紧凑，制作精良，被誉为国产古装剧的新标杆。',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    duration: '48集',
    type: 'tv',
    isHot: true,
    isNew: false,
    isClassic: false,
    episodes: '全48集',
    region: '中国大陆',
  },
  {
    id: 'movie-001',
    title: '流浪地球2',
    year: 2023,
    category: '电影',
    categorySlug: 'movies',
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20epic%20cinematic%20lighting%2C%20dramatic%20contrast%2C%20film%20poster%20style%20with%20cool%20blue%20tones%20and%20warm%20orange%20highlights%2C%20blockbuster%20aesthetic&width=600&height=800&seq=movie-001&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '173分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    isClassic: false,
    region: '中国大陆',
  },
  {
    id: 'tv-002',
    title: '狂飙',
    year: 2023,
    category: '电视剧',
    categorySlug: 'tv-series',
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20intense%20atmosphere%2C%20dark%20alleyway%20scene%2C%20two%20men%20in%20confrontation%2C%20noir%20lighting%2C%20dramatic%20shadows%2C%20film%20poster%20style%20with%20red%20and%20black%20color%20scheme&width=600&height=800&seq=tv-002&orientation=portrait',
    description: '该剧讲述了以一线刑警安欣为代表的正义力量，与黑恶势力展开的长达二十年的生死搏斗故事，通过群像叙事展现扫黑行动中的黑白较量和复杂人性。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    duration: '39集',
    type: 'tv',
    isHot: true,
    isNew: true,
    isClassic: false,
    episodes: '全39集',
    region: '中国大陆',
  },
  {
    id: 'movie-002',
    title: '满江红',
    year: 2023,
    category: '电影',
    categorySlug: 'movies',
    rating: 7.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%20set%20in%20Song%20Dynasty%2C%20courtyard%20scene%20with%20soldiers%2C%20dark%20red%20color%20palette%2C%20mysterious%20atmosphere%2C%20film%20poster%20style%20with%20traditional%20Chinese%20architecture&width=600&height=800&seq=movie-002&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相府邸，所携密信不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这巨大阴谋之中。',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    duration: '159分钟',
    type: 'movie',
    isHot: false,
    isNew: true,
    isClassic: false,
    region: '中国大陆',
  },
  {
    id: 'tv-003',
    title: '三体',
    year: 2023,
    category: '电视剧',
    categorySlug: 'tv-series',
    rating: 8.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20mysterious%20cosmic%20background%2C%20three%20suns%20in%20sky%2C%20dark%20blue%20and%20purple%20tones%2C%20radio%20telescope%20silhouette%2C%20film%20poster%20style%20with%20cosmic%20horror%20aesthetic&width=600&height=800&seq=tv-003&orientation=portrait',
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。纳米科学家汪淼被警官史强带到联合作战中心，潜入名为"科学边界"的组织，揭开地外文明"三体"世界的神秘面纱。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    duration: '30集',
    type: 'tv',
    isHot: false,
    isNew: true,
    isClassic: false,
    episodes: '全30集',
    region: '中国大陆',
  },
  {
    id: 'variety-001',
    title: '乘风破浪的姐姐',
    year: 2023,
    category: '综艺',
    categorySlug: 'variety',
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20female%20celebrities%20on%20stage%2C%20glamorous%20lighting%2C%20performance%20vibe%2C%20colorful%20stage%20lights%2C%20entertainment%20show%20poster%20style%20with%20bright%20pink%20and%20gold%20tones&width=600&height=800&seq=variety-001&orientation=portrait',
    description: '节目集结了30位年龄30+的女艺人，通过多轮竞演，最终选拔出7位成员组成女团。展现了成熟女性的独特魅力，鼓励女性不惧年龄，勇敢追求梦想。',
    director: '晏吉',
    cast: ['谢娜', 'Ella', '蔡少芬', '贾静雯'],
    duration: '12期',
    type: 'variety',
    isHot: true,
    isNew: false,
    isClassic: false,
    episodes: '全12期',
    region: '中国大陆',
  },
  {
    id: 'anime-001',
    title: '斗罗大陆',
    year: 2018,
    category: '动漫',
    categorySlug: 'anime',
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%203D%20animation%20poster%20with%20martial%20arts%20fantasy%20theme%2C%20young%20warrior%20with%20glowing%20weapon%2C%20magical%20forest%20background%2C%20epic%20fantasy%20atmosphere%2C%20animation%20poster%20style%20with%20vibrant%20colors&width=600&height=800&seq=anime-001&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。在这片神奇的土地上，他展开了魂师修炼之旅，一步步走向巅峰。',
    director: '沈乐平',
    cast: ['配音：沈磊', '配音：陶典', '配音：黄莺'],
    duration: '更新至263集',
    type: 'anime',
    isHot: false,
    isNew: false,
    isClassic: true,
    episodes: '连载中',
    region: '中国大陆',
  },
  {
    id: 'doc-001',
    title: '我在故宫修文物',
    year: 2016,
    category: '纪录片',
    categorySlug: 'documentary',
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20poster%20about%20Forbidden%20City%20antique%20restoration%2C%20close-up%20of%20hands%20restoring%20ancient%20artifact%2C%20warm%20workshop%20lighting%2C%20traditional%20Chinese%20craftsmanship%2C%20documentary%20film%20poster%20style&width=600&height=800&seq=doc-001&orientation=portrait',
    description: '该纪录片重点记录故宫书画、青铜器、宫廷钟表、木器、陶瓷、漆器、百宝镶嵌、宫廷织绣等领域的稀世珍奇文物的修复过程和修复者的生活故事，展现了中国文物修复的顶级技艺。',
    director: '叶君',
    cast: ['王津', '亓昊楠', '屈峰', '王五胜'],
    duration: '3集',
    type: 'documentary',
    isHot: false,
    isNew: false,
    isClassic: true,
    episodes: '全3集',
    region: '中国大陆',
  },
  {
    id: 'movie-003',
    title: '长津湖',
    year: 2021,
    category: '电影',
    categorySlug: 'movies',
    rating: 7.6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20with%20soldiers%20in%20snowy%20battlefield%2C%20epic%20winter%20warfare%20scene%2C%20dramatic%20cold%20blue%20tones%2C%20heroic%20atmosphere%2C%20blockbuster%20film%20poster%20style&width=600&height=800&seq=movie-003&orientation=portrait',
    description: '1950年，中国志愿军部队在极度严酷环境下，东线作战部队凭着钢铁意志和英勇无畏的战斗精神，扭转战场态势，为长津湖战役胜利作出重要贡献。',
    director: '陈凯歌',
    cast: ['吴京', '易烊千玺', '段奕宏', '朱亚文'],
    duration: '176分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    isClassic: true,
    region: '中国大陆',
  },
  {
    id: 'tv-004',
    title: '甄嬛传',
    year: 2011,
    category: '电视剧',
    categorySlug: 'tv-series',
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20poster%20with%20Qing%20Dynasty%20imperial%20concubine%2C%20ornate%20traditional%20costume%2C%20palace%20interior%20background%2C%20elegant%20and%20mysterious%20atmosphere%2C%20film%20poster%20style%20with%20rich%20red%20and%20gold%20tones&width=600&height=800&seq=tv-004&orientation=portrait',
    description: '该剧讲述了少女甄嬛从一个不谙世事的单纯少女成长为一个善于权谋的深宫妇人的故事。剧情精妙，制作精良，是国产宫斗剧的巅峰之作，至今仍被观众反复观看。',
    director: '郑晓龙',
    cast: ['孙俪', '陈建斌', '蔡少芬', '蒋欣'],
    duration: '76集',
    type: 'tv',
    isHot: false,
    isNew: false,
    isClassic: true,
    episodes: '全76集',
    region: '中国大陆',
  },
  {
    id: 'variety-002',
    title: '奔跑吧兄弟',
    year: 2023,
    category: '综艺',
    categorySlug: 'variety',
    rating: 7.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20game%20variety%20show%20poster%20with%20celebrities%20running%20in%20colorful%20sportswear%2C%20dynamic%20action%20pose%2C%20sunny%20outdoor%20background%2C%20fun%20and%20energetic%20vibe%2C%20entertainment%20poster%20style&width=600&height=800&seq=variety-002&orientation=portrait',
    description: '节目采用主题模式，在设置上融入更具有时代感和地区意义的主线，艺人分为不同的队伍进行比赛，最后获胜一方获得称号或奖品。',
    director: '姚译添',
    cast: ['李晨', 'Angelababy', '郑恺', '沙溢'],
    duration: '12期',
    type: 'variety',
    isHot: false,
    isNew: true,
    isClassic: false,
    episodes: '全12期',
    region: '中国大陆',
  },
  {
    id: 'anime-002',
    title: '哪吒之魔童降世',
    year: 2019,
    category: '动漫',
    categorySlug: 'anime',
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20mythological%20character%20Nezha%2C%20fiery%20red%20color%20scheme%2C%20dynamic%20action%20pose%20with%20fire%20wheel%2C%20epic%20fantasy%20atmosphere%2C%20animation%20film%20poster%20style&width=600&height=800&seq=anime-002&orientation=portrait',
    description: '天地灵气孕育出一颗混元珠，元始天尊将其提炼成灵珠和魔丸。灵珠投胎为人，助周伐纣时可堪大用；而魔丸则会诞出魔王，为祸人间。然而阴差阳错，灵珠和魔丸竟被调包。',
    director: '饺子',
    cast: ['配音：吕艳婷', '配音：囧森瑟夫', '配音：瀚墨'],
    duration: '110分钟',
    type: 'anime',
    isHot: false,
    isNew: false,
    isClassic: true,
    region: '中国大陆',
  },
  {
    id: 'doc-002',
    title: '舌尖上的中国',
    year: 2012,
    category: '纪录片',
    categorySlug: 'documentary',
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20beautiful%20traditional%20Chinese%20cuisine%20close-up%2C%20steaming%20hot%20dish%2C%20warm%20kitchen%20lighting%2C%20rustic%20cooking%20scene%2C%20documentary%20poster%20style%20with%20rich%20warm%20tones&width=600&height=800&seq=doc-002&orientation=portrait',
    description: '围绕中国人对美食和生活的美好追求，用具体人物故事串联起中国各地美食生态，展现了中国饮食文化的博大精深和源远流长。',
    director: '陈晓卿',
    cast: ['旁白：李立宏'],
    duration: '7集',
    type: 'documentary',
    isHot: false,
    isNew: false,
    isClassic: true,
    episodes: '全7集',
    region: '中国大陆',
  },
  {
    id: 'movie-004',
    title: '消失的她',
    year: 2023,
    category: '电影',
    categorySlug: 'movies',
    rating: 7.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20movie%20poster%20with%20mysterious%20woman%20silhouette%2C%20tropical%20island%20night%20scene%2C%20dark%20and%20moody%20atmosphere%2C%20psychological%20thriller%20vibe%2C%20film%20poster%20style%20with%20teal%20and%20orange%20tones&width=600&height=800&seq=movie-004&orientation=portrait',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失。就在何非苦寻无果之时，妻子再次现身，何非却坚持眼前的女人并非自己的妻子。夫妻二人似乎都有着不可告人的秘密。',
    director: '崔睿',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '121分钟',
    type: 'movie',
    isHot: false,
    isNew: true,
    isClassic: false,
    region: '中国大陆',
  },
  {
    id: 'tv-005',
    title: '庆余年',
    year: 2019,
    category: '电视剧',
    categorySlug: 'tv-series',
    rating: 7.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20period%20drama%20poster%20with%20young%20scholar%20in%20ancient%20Chinese%20setting%2C%20mysterious%20palace%20intrigue%2C%20warm%20golden%20lighting%2C%20epic%20storytelling%20vibe%2C%20film%20poster%20style&width=600&height=800&seq=tv-005&orientation=portrait',
    description: '某大学文学史专业的学生张庆熟读古典名著，但他用现代观念剖析古代文学史的论文命题不被叶教授所认可。为了让叶教授成为自己的研究生导师，张庆决定通过写小说的方式，进一步阐述自己的观点。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '46集',
    type: 'tv',
    isHot: true,
    isNew: false,
    isClassic: false,
    episodes: '全46集',
    region: '中国大陆',
  },
  {
    id: 'movie-005',
    title: '独行月球',
    year: 2022,
    category: '电影',
    categorySlug: 'movies',
    rating: 6.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20comedy%20movie%20poster%20with%20astronaut%20alone%20on%20moon%20surface%2C%20humorous%20pose%2C%20lunar%20landscape%20with%20Earth%20in%20background%2C%20light-hearted%20blockbuster%20style&width=600&height=800&seq=movie-005&orientation=portrait',
    description: '人类为抵御小行星的撞击，在月球部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因意外错过撤离通知，一个人落在了月球。不料月盾计划失败，独孤月成为了"宇宙最后的人类"。',
    director: '张吃鱼',
    cast: ['沈腾', '马丽', '常远', '李诚儒'],
    duration: '122分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    isClassic: true,
    region: '中国大陆',
  },
];

export const getHotMovies = () => movies.filter(m => m.isHot);
export const getNewMovies = () => movies.filter(m => m.isNew);
export const getClassicMovies = () => movies.filter(m => m.isClassic);
export const getMoviesByCategory = (slug: string) => movies.filter(m => m.categorySlug === slug);
export const getMovieById = (id: string) => movies.find(m => m.id === id);

export const aboutInfo = {
  brandName: '大师兄影视',
  slogan: '海量片库，一网打尽',
  introduction: '大师兄影视成立于2018年，是国内领先的在线影视内容聚合平台。我们致力于为广大影视爱好者提供最新、最全、最优质的影视内容，涵盖电视剧、电影、综艺、动漫、纪录片等多种类型。',
  mission: '让每一个人都能轻松享受高品质的影视内容，不卡顿、不缓冲，带来极致的观影体验。',
  features: [
    { title: '海量片库', description: '汇聚全网热门影视资源，电视剧、电影、综艺、动漫、纪录片应有尽有', icon: 'ri-database-2-line' },
    { title: '高清画质', description: '支持1080P高清画质，带来影院级观影体验', icon: 'ri-4k-line' },
    { title: '秒开播放', description: '采用先进CDN加速技术，视频秒开不缓冲，流畅观影', icon: 'ri-flashlight-line' },
    { title: '每日更新', description: '每日更新最新内容，热播剧集同步追更，精彩不错过', icon: 'ri-refresh-line' },
  ],
  stats: [
    { value: '10万+', label: '影视资源' },
    { value: '5000万+', label: '月活用户' },
    { value: '99.9%', label: '服务可用率' },
    { value: '7×24', label: '技术服务' },
  ],
  faqs: [
    { question: '大师兄影视是否需要注册账号？', answer: '不需要。大师兄影视所有内容均可免费在线观看，无需注册或登录，打开即看，方便快捷。' },
    { question: '影视内容是否支持高清播放？', answer: '是的，我们支持标清、高清和超清多种画质，系统会根据您的网络状况自动选择最佳画质，您也可以手动切换。' },
    { question: '可以在手机上观看吗？', answer: '可以。大师兄影视完美适配手机、平板和电脑等多种设备，随时随地畅享观影体验。' },
    { question: '内容更新频率是怎样的？', answer: '我们每日更新最新影视内容，热播剧集同步追更。新电影上线后24小时内即可在平台观看，综艺节目播出后当天更新。' },
    { question: '遇到播放问题怎么办？', answer: '您可以尝试切换播放线路或刷新页面。如果问题持续存在，请通过"联系我们"页面反馈，我们的技术团队会第一时间处理。' },
  ],
  contact: {
    email: 'contact@dashixiong.tv',
    wechat: '大师兄影视官方',
    weibo: '@大师兄影视',
    address: '北京市朝阳区望京SOHO T3',
    phone: '400-888-8888',
  },
};